import { type PayloadAction, createAction, createReducer } from '@reduxjs/toolkit';
import type { BillingPersonalizationResponse } from 'reactApp/api/billing/personalization/BillingPersonalizationAPICall.types';
import { normalizeBillingPersonalizationTariffsData } from 'reactApp/modules/billingPersonalization/billingPersonalization.helpers';
import type { BillingPersonalizationState } from 'reactApp/modules/billingPersonalization/billingPersonalization.types';

const emptyBillingPersonalizationData: BillingPersonalizationResponse = {
    mtime: 0,
    data1: {},
};

export const initialState: BillingPersonalizationState = {
    isLoading: false,
    isLoaded: false,
    hasError: false,
    rawData: emptyBillingPersonalizationData,
};

export const billingPersonalizationLoadRequest = createAction('billing/personalization/load/request');
export const billingPersonalizationLoadSuccess = createAction<BillingPersonalizationResponse>('billing/personalization/load/success');
export const billingPersonalizationLoadFailure = createAction('billing/personalization/load/failure');

export const billingPersonalizationReducer = createReducer(initialState, {
    [billingPersonalizationLoadRequest.type]: (state: BillingPersonalizationState) => {
        state.isLoading = true;
        state.isLoaded = false;
        state.hasError = false;
    },
    [billingPersonalizationLoadSuccess.type]: (
        state: BillingPersonalizationState,
        { payload }: PayloadAction<BillingPersonalizationResponse>
    ) => {
        const { data1 } = payload;

        state.isLoading = false;
        state.isLoaded = true;
        state.hasError = false;
        state.rawData = payload;
        state.web = normalizeBillingPersonalizationTariffsData(data1?.promo_quota_web);
        state.iOS = normalizeBillingPersonalizationTariffsData(data1?.promo_quota_ios);
        state.android = normalizeBillingPersonalizationTariffsData(data1?.promo_quota_android);
    },
    [billingPersonalizationLoadFailure.type]: (state: BillingPersonalizationState) => {
        state.isLoading = false;
        state.isLoaded = true;
        state.hasError = true;
    },
});
